import React, { useState, useEffect } from 'react';
import './Challenge.css';
import { CSVLink } from 'react-csv';
import Select from 'react-select';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';
const LeaveReport = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [coachingLeaveReport, setCoachingLeaveReport] = useState([]);
  const [playingLeaveReport, setPlayingLeaveReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reportType, setReportType] = useState('coaching');
  const [error, setError] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const today = new Date();
  const addsevenDays= new Date();
  const fiveDaysAgo = new Date();
  const token = localStorage.getItem('auth-token');
  fiveDaysAgo.setDate(today.getDate() - 5);
  addsevenDays.setDate(today.getDate() + 7);
  const formatForDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  const [fromDate, setFromDate] = useState(formatForDate(fiveDaysAgo));
  const [toDate, setToDate] = useState(formatForDate(addsevenDays));


  const fetchReports = async () => {
    setLoading(false)
    setError('')
    try {
      const fetchData = async (type) => {
        const response = await fetch(`${process.env.REACT_APP_API_LEAVE_REPORT}?start_date=${fromDate}&end_date=${toDate}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,

          },
        });

        const data = await response.json();
        return type === 'coaching'
          ? data?.data?.CoachingLeaveReport || []
          : data?.data?.PlayingLeaveReport || [];
      };

      const coachingData = await fetchData('coaching');
      const playingData = await fetchData('playing');

      setCoachingLeaveReport(formatReportData(coachingData, 'coaching'));
      setPlayingLeaveReport(formatReportData(playingData, 'playing'));
    } catch (err) {
      setError('Error fetching data: ' + err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchReports();
  }, [fromDate, toDate]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
  };

  const formatReportData = (apiData, type) => {
    return apiData.map((item) => {
      const baseItem = {
        name: item?.name || '',
        startDate: formatDate(item?.startDate || item?.start_date),
        endDate: formatDate(item?.endDate || item?.end_date),
        status: item?.status === 0 ? 'No' : 'Yes',
        isCancel: item?.isCancel ? 'Yes' : 'No',
        isEdit: item?.isEdit ? 'Yes' : 'No',
      };

      if (type === 'coaching') {
        return {
          ...baseItem,
          playerName: item?.name || '',
          coachingstatus: item?.status === false ? 'No' : 'Yes',
          mobileNumber: item?.mobileNumber || '',
          parentMobileNumber: item?.parentMobileNumber || '',
          academyName: item?.academyName || item?.academy_name || '',
          batchName: item?.batchName || item?.batch_name || '',
          leaveCredit: `${item?.leave_credit || 0} days`,
          leaveDays: `${item?.pauseDays || item?.leave_days || 0} days`,
          amount: item?.amount ? item?.amount.toString() : '0',
          appliedOn: item?.applied_on || '',
          missedSession: item?.missedSession?.toString() || '0',
          sportName: item?.sportName || '',
          batchStartTime: item?.batchStartTime || '',
          batchEndTime: item?.batchEndTime || '',
          cancelledDate: item?.cancelledDate || '',

        };
      } else {
        return {
          ...baseItem,
          playerName: item?.name || '',
          mobileNumber: item?.mobileNumber || '',
          parentMobileNumber: item?.parentMobileNumber || '',
          leaveDays: `${item?.pauseDays || 0} days`,
          missedSession: item?.missedSession?.toString() || '0',
          cancelledDate: item?.cancelledDate || '',
        };
      }
    });
  };


  const searchInAllFields = (item) => {
    return Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const filteredCoaching = coachingLeaveReport.filter(searchInAllFields);
  const filteredPlaying = playingLeaveReport.filter(searchInAllFields);

  const coachingHeaders = [
    { label: "Academy Name", key: "academyName" },
    { label: "Player Name", key: "playerName" },
    { label: "Mobile Number", key: "mobileNumber" },
    { label: "Parent Number", key: "parentMobileNumber" },
    { label: "Cancelled Date", key: "cancelledDate" },
    { label: "Batch Name", key: "batchName" },
    { label: "Sport Name", key: "sportName" },
    { label: "Amount", key: "amount" },
    { label: "Missed Sessions", key: "missedSession" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },
    { label: "Status", key: "coachingstatus" },
    { label: "Cancel", key: "isCancel" },
    { label: "Edit", key: "isEdit" },
  ];

  const playingHeaders = [
    { label: "Player Name", key: "playerName" },
    { label: "Mobile Number", key: "mobileNumber" },
    { label: "Parent Number", key: "parentMobileNumber" },
    { label: "Cancelled Date", key: "cancelledDate" },
    { label: "Leave Days", key: "leaveDays" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },
    { label: "Status", key: "status" },
    { label: "Cancel", key: "isCancel" },
    { label: "Edit", key: "isEdit" },
  ];

  const reportTypeOptions = [
    { value: 'coaching', label: 'Coaching Leave Report' },
    { value: 'playing', label: 'Playing Leave Report' }
  ];

  const sortData = (data) => {
    if (sortConfig.key) {
      return [...data].sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        const getComparableValue = (value) => {
          if (value === null || value === undefined) return '';
          if (typeof value === 'string') return value.trim().toLowerCase();
          return value;
        };

        const extractNumericValue = (value) => {
          if (value === null || value === undefined) return 0;
          if (typeof value === 'string') {
            const numericMatch = value.match(/[\d.-]+/);
            return numericMatch ? parseFloat(numericMatch[0]) : 0;
          }
          return value;
        };

        const parseDateValue = (value) => {
          const date = new Date(value);
          return isNaN(date.getTime()) ? -Infinity : date.getTime();
        };

        let comparison = 0;


        if (
          sortConfig.key === 'startDate' ||
          sortConfig.key === 'endDate' ||
          sortConfig.key === 'appliedOn' ||
          sortConfig.key === 'cancelledDate'
        ) {
          comparison = parseDateValue(aValue) - parseDateValue(bValue);
        }


        else if (
          typeof aValue === 'string' &&
          (aValue.toLowerCase() === 'yes' || aValue.toLowerCase() === 'no')
        ) {
          comparison = getComparableValue(aValue).localeCompare(getComparableValue(bValue));
        }


        else if (typeof aValue === 'string') {
          comparison = getComparableValue(aValue).localeCompare(getComparableValue(bValue));
        }


        else {
          comparison = extractNumericValue(aValue) - extractNumericValue(bValue);
        }

        return sortConfig.direction === 'ascending' ? comparison : -comparison;
      });
    }
    return data;
  };


  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handleItemsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const currentData = reportType === 'coaching' ? filteredCoaching : filteredPlaying;
  const sortedData = sortData(currentData);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(currentData.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = currentData.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${reportType ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={reportTypeOptions}
            value={reportTypeOptions.find(option => option.value === reportType)}
            onChange={(selectedOption) => {
              setReportType(selectedOption?.value || 'coaching');
              setCurrentPage(1);
            }}
            placeholder="Select Report Type"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {reportType && <label htmlFor="selectedReportType">Report Type</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${fromDate ? "has-value" : ""}`}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={formatForDate(addsevenDays)}
          />
          {fromDate && <label htmlFor="fromDate">Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${toDate ? "has-value" : ""}`}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={formatForDate(addsevenDays)}
          />
          {toDate && <label htmlFor="toDate">End Date</label>}
        </div>


      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <CSVLink
  data={reportType === 'coaching' ? filteredCoaching : filteredPlaying}
  headers={reportType === 'coaching' ? coachingHeaders : playingHeaders}
          filename={`${reportType}_leave_report.csv`}
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>


      </div>




      <>
        <div className="items-and-dues">
          <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
            <option value={10}>10 items per page</option>
            <option value={50}>50 items per page</option>
            <option value={75}>75 items per page</option>
            <option value={100}>100 items per page</option>
          </select>
          <div className="pagination-selector">
            <div className="button-group">
              <div className="group-label">Items per page:</div>
              <div className="button-options">
                {[10, 50, 75, 100].map((option) => (
                  <button
                    key={option}
                    onClick={() =>
                      handleItemsPerPageChange({ target: { value: option } })
                    }
                    className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                  >
                    <span className="button-text">{option}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
          <button className="tt-action-btn" onClick={fetchReports}>
            <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
            Refresh
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}

        {!loading && !error && sortedData.length === 0 && (
          <div className="error-message">No data available</div>
        )}
        {loading && (
          <div className="premium-loader">
            <div className="progress-track">
              <div className="progress-bar"></div>
            </div>
            <div className="status-text">
              <span>L</span>
              <span>O</span>
              <span>A</span>
              <span>D</span>
              <span>I</span>
              <span>N</span>
              <span>G</span>
            </div>
          </div>
        )}

        <div className="tt-table-container">
          <table className="tt-table">
            <thead>
              <tr className="challenges-header-row">
                {(reportType === 'coaching' ? coachingHeaders : playingHeaders).map(({ key, label }) => (
                  <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                    <div className="th-content">
                      <span>{label}</span>
                      <FiChevronDown
                        className={`sort-icon ${sortConfig.key === key ? 'active' : ''} 
              ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                      />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {currentRows.map((row, index) => (
                <tr key={index}>
                  {(reportType === 'coaching' ? coachingHeaders : playingHeaders).map((header) => (
                    <td key={header.key}>{row[header.key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <div className="showing-entries">
            Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
          </div>
          <button
            className="prev-button"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {renderPagination()}
          <button
            className="next-button"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>


      </>

    </div>
  );
};

export default LeaveReport;